var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyJustCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u2714",
    clipPath: "url(#clip0_452_212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.53559 13.1726C6.27959 13.1726 6.02359 13.075 5.82839 12.8798L1.21279 8.26383C0.821993 7.87343 0.821993 7.24023 1.21279 6.84983C1.60319 6.45903 2.23679 6.45903 2.62679 6.84983L6.53519 10.7582L13.3728 3.92103C13.7632 3.53023 14.3968 3.53023 14.7868 3.92103C15.1776 4.31143 15.1776 4.94463 14.7868 5.33503L7.24239 12.8794C7.04719 13.0746 6.79119 13.1722 6.53519 13.1722L6.53559 13.1726Z",
    fill: "#1E6EF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyJustCheck);
export default __webpack_public_path__ + "static/media/daily_just_check.d3518625a5fa9ba2a0005c30a731bcd7.svg";
export { ForwardRef as ReactComponent };